export default "__VITE_ASSET__B0p2HdZn__"